var _path, _path2, _rect, _path3, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessControl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 68,
    viewBox: "0 0 38 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38163 7.96725C11.997 5.47441 15.4714 4.0838 19.0845 4.0838C22.6975 4.0838 26.172 5.47441 28.7873 7.96725C29.1629 8.29774 29.6508 8.47182 30.1508 8.45374C30.6508 8.43566 31.1248 8.22678 31.4756 7.87001C31.8263 7.51325 32.0271 7.03571 32.0367 6.5355C32.0463 6.03529 31.8639 5.5504 31.5271 5.18047C28.2208 1.88642 23.7438 0.0368652 19.0766 0.0368652C14.4095 0.0368652 9.93249 1.88642 6.62616 5.18047C6.42638 5.35625 6.26455 5.57094 6.15056 5.8114C6.03656 6.05185 5.97281 6.31303 5.96319 6.57897C5.95357 6.8449 5.99829 7.11 6.09461 7.35807C6.19094 7.60613 6.33684 7.83195 6.5234 8.02171C6.70996 8.21147 6.93326 8.36118 7.17965 8.46171C7.42604 8.56223 7.69035 8.61145 7.95641 8.60635C8.22247 8.60125 8.48469 8.54195 8.72705 8.43206C8.96941 8.32217 9.18682 8.16401 9.36597 7.96725H9.38163Z",
    fill: "#2F343D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0867 10.7646C11.9068 10.9486 11.7649 11.1662 11.6691 11.4051C11.5733 11.6439 11.5255 11.8993 11.5284 12.1566C11.5314 12.414 11.5849 12.6682 11.6861 12.9048C11.7872 13.1414 11.934 13.3558 12.118 13.5357C12.302 13.7156 12.5197 13.8575 12.7585 13.9533C12.9974 14.0491 13.2527 14.0969 13.5101 14.094C13.7674 14.0911 14.0216 14.0375 14.2582 13.9363C14.4949 13.8352 14.7092 13.6884 14.8891 13.5044C15.9947 12.4442 17.4671 11.8523 18.9989 11.8523C20.5306 11.8523 22.0031 12.4442 23.1086 13.5044C23.4719 13.8765 23.9682 14.0891 24.4882 14.0954C25.0083 14.1016 25.5095 13.901 25.8817 13.5377C26.2538 13.1743 26.4664 12.6781 26.4726 12.158C26.4788 11.638 26.2782 11.1367 25.9149 10.7646C24.0607 8.96993 21.5813 7.96655 19.0008 7.96655C16.4203 7.96655 13.9409 8.96993 12.0867 10.7646Z",
    fill: "#2F343D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.8994,
    y: 20.7947,
    width: 45.2052,
    height: 33.7983,
    rx: 4,
    transform: "rotate(90 35.8994 20.7947)",
    fill: "white",
    stroke: "#2F343D",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1025 31.3491C12.1025 30.2446 12.998 29.3491 14.1025 29.3491H25.1025C26.2071 29.3491 27.1025 30.2446 27.1025 31.3491C27.1025 32.4537 26.2071 33.3491 25.1025 33.3491H14.1025C12.998 33.3491 12.1025 32.4537 12.1025 31.3491Z",
    fill: "#2F343D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9995,
    cy: 53.1885,
    r: 6,
    fill: "#FF4935"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessControl);
export default __webpack_public_path__ + "static/media/accessControl.76e169d497173a3ae69966c53750bcf3.svg";
export { ForwardRef as ReactComponent };